export const reasonText = ({ code, advancePaymentId }) => {
  const ref = advancePaymentId ? `#${advancePaymentId}` : "";
  const who = ref || "Um dos pacotes";
  switch (code) {
    case "MIN_TWO_PACKAGES":
      return "Marque 2 ou mais pacotes do mesmo médico e da mesma empresa.";
    case "PACKAGE_NOT_FOUND":
      return ref ? `Pacote ${ref} não encontrado.` : "Pacote não encontrado.";
    case "DIFFERENT_COMPANY":
      return "Empresas diferentes. Só junta pacotes da mesma empresa.";
    case "DIFFERENT_DOCTOR":
      return "Médicos diferentes. O contrato, a conta e a PJ são do médico.";
    case "DIFFERENT_STATUS":
      return "Status diferentes. Só junta pacotes no mesmo status.";
    case "STATUS_NOT_MERGEABLE":
      return `${who} não está com a empresa nem aguardando contrato.`;
    case "CONTRACT_GENERATED":
      return `${who} já teve o contrato gerado. Depois do contrato não dá para juntar.`;
    case "PAYMENT_DATE_MISMATCH":
      return `Data de pagamento do pacote diferente${ref ? ` (${ref})` : ""}. Nada é recalculado, então as datas precisam ser iguais.`;
    case "PAYMENT_DATE_PARTIAL":
      return `Um pacote tem data de pagamento e outro não${ref ? ` (${ref} sem data)` : ""}. Defina a data de pagamento${ref ? ` de ${ref}` : ""} antes de juntar.`;
    case "ALREADY_MERGED":
      return `${who} já foi agrupado em outro pacote.`;
    case "EMPTY_PACKAGE":
      return `${who} não tem plantões.`;
    case "ACTOR_REQUIRED":
      return "Informe quem está juntando (de 2 a 80 caracteres).";
    case "FEATURE_DISABLED":
      return "Juntar pacotes foi desligado agora há pouco. Recarregue a página.";
    default:
      return `Não dá para juntar${ref ? ` (${ref})` : ""}: ${code}.`;
  }
};
